<template>
  <form-group :label="label" :errors="errors">
    <loader v-if="isLoading" />
    <span v-else :class="{ 'uk-text-danger': isInvalid }">
      <slot>
        {{value}}
      </slot>
    </span>
  </form-group>
</template>

<script>
import FormGroup from '@/components/FormGroup';
import Loader from '@/components/Loader';

export default {
  name: 'readonly-form-field',
  props: {
    label: String,
    value: String,
    errors: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormGroup,
    Loader,
  },
  computed: {
    isInvalid() {
      return this.errors && this.errors.length > 0;
    },
    isValid() {
      return !this.isInvalid;
    },
  },
  methods: {
    onFocus() {},
  },
};
</script>



// WEBPACK FOOTER //
// ReadonlyFormField.vue?5a1ca924